import React from 'react'
import classNames from 'classnames'

const STAR_VALUES = [1, 2, 3, 4, 5]

const StarIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 2.5l2.8 6 6.6.6-5 4.4 1.5 6.4L12 16.8 6.1 19.9l1.5-6.4-5-4.4 6.6-.6z" />
  </svg>
)

const StarRatingField = ({ name, label, value, onChange, allowNA = false, helperText }) => {
  const groupId = `${name}-rating-group`

  return (
    <div className="c-feedback-field">
      <label className="c-form__label" htmlFor={groupId}>
        {label}
      </label>
      {helperText ? <p className="c-feedback-field__helper c-feedback-form__copy">{helperText}</p> : null}
      <div className="c-feedback-rating" role="group" aria-labelledby={groupId} id={groupId}>
        {STAR_VALUES.map((ratingValue) => {
          const isSelected = value !== 'N/A' && Number(value) >= ratingValue

          return (
            <button
              key={`${name}-${ratingValue}`}
              type="button"
              className={classNames('c-feedback-rating__star', { 'is-selected': isSelected })}
              onClick={() => onChange(String(ratingValue))}
              aria-label={`${ratingValue} star${ratingValue > 1 ? 's' : ''}`}
            >
              <StarIcon />
            </button>
          )
        })}
        {allowNA && (
          <button
            type="button"
            className={classNames('c-feedback-rating__na', { 'is-selected': value === 'N/A' })}
            onClick={() => onChange('N/A')}
          >
            N/A
          </button>
        )}
      </div>
    </div>
  )
}

export default StarRatingField

